import React from 'react';
import styled from '@emotion/styled';
import { ITheme } from '../../../../../ui';
import { useTranslation } from '../../../../shared/i18n/translate/useTranslation';
import { ErrorBar } from '../../../../shared/components';
import { trackPromotionResult } from '../shared/analytics/custom/trackPromotionResult';
import themed from '../../../../../ui/themer/themed';
import Responsive from '../../../../../ui/utils/Responsive';
import ContentWrap from '../../../../../ui/components/Layout/ContentWrap';

interface IPromoCodeResultProps {
	isValid: boolean;
	promoCode: string;
}

export const PromoCodeResult = ({
	isValid,
	promoCode,
}: IPromoCodeResultProps) => {
	const { t } = useTranslation();

	trackPromotionResult(promoCode, isValid);

	const message = isValid
		? t('parking_options_message_valid_promocode')
		: t('parking_options_message_invalid_promocode');

	return (
		<ContentWrap>
			<StyledPromoCodeResult
				role={isValid ? 'status' : 'alert'}
				isValid={isValid}
			>
				{message}
			</StyledPromoCodeResult>
		</ContentWrap>
	);
};

const StyledPromoCodeResult = styled(ErrorBar)<{ isValid: boolean }, ITheme>`
	margin-bottom: 40px;
	background: ${themed(({ color }, { isValid }) =>
		isValid ? color.state.success : color.state.error,
	)};

	${Responsive.getMediaQueryForBreakpoint('mobileXL')} {
		margin-bottom: 24px;
	}
`;
